<template>
  <NavBar></NavBar>
   Service Prices management
</template>

<script>
import { defineComponent } from 'vue';
import useGetLoggedIn from "@/composables/useGetLoggedIn"
import {log} from "@/composables/useLog";
import NavBar from "@/components/NavBar.vue";
import store from "@/store";

// Components

export default defineComponent({
  name: 'DashBoard',
  components: {
    NavBar
  },
  data() {
    return {
      showToken:false,
      token:'',
      clientsListLoaded:false
    }
  },
  methods: {
    showClientsList() {
      // alert("am primit emisia")
      this.clientsListLoaded=true
    }
  },
  created() {
    const {getLoggedIn, user, loggedIn, userAvatar,token}=useGetLoggedIn()
    getLoggedIn().then(()=>{
      // timestamp("autorizare in HomeloggedIn after getLoggedIn")
      log ("dupa created in Dashboard avem:")
      log("autorizare in Dashboard after getLoggedIn")
      log("user:")
      log(user)
      log("loggedIn: " + loggedIn.value)
      log("token: " + token.value)
      log("userAvatar: " + userAvatar)
      this.token=store.getters.getToken
      // this.showToken=true
    })
  }
});
</script>
